// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"140b8e80","258":"b7460fc4","453":"8f73bac5","525":"1532cb75","631":"5ddcadac","746":"345bfd04","903":"a09b9820"}[chunkId] + ".chunk.js";
};